<div *ngIf="loading" class="loading-small-screen-scroll" style="left:56%;" align="center">
    <img src="assets/images/loading.svg" alt="Loader" />
</div>